module.exports = __webpack_public_path__ + "static/media/linkdin.01a69de0.svg";